import { render, staticRenderFns } from "./ERegistrationRegisterCPSSuccessView.vue?vue&type=template&id=105f885f&scoped=true&"
import script from "./ERegistrationRegisterCPSSuccessView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationRegisterCPSSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./ERegistrationRegisterCPSSuccessView.vue?vue&type=style&index=0&id=105f885f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f885f",
  null
  
)

/* custom blocks */
import block0 from "./ERegistrationRegisterCPSSuccessView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports